import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, } from 'rxjs';
import { AbstractRestService, GenericLambdaReturn } from '@gea-mes/cognito';
import { TeamWork, WorkUpdatesType, Region, TeamWorkFormatted, EditVariantWork, TeamVersion } from '../../shared/models/type-list';


@Injectable({
  providedIn: 'root'
})

export class WorkService extends AbstractRestService {
  postInit(): void{}

  public variant_work$ = new BehaviorSubject<EditVariantWork>(null)

  getRegions(team_id: number): Observable<GenericLambdaReturn<Region[]>>
  {
    let params: any = {};
    params.TeamID = team_id;

    return this.get({
      ApiResource: "/region",
      data: params,
      repeatCall: false
    });
  }


  createWorkBlock(plant_name:string, work_type: string, time_to_complete: number, region_id: number, work_description: string, frequency: number, variant_id: number, team_id: number, version_id: number, service_config_id: number):Observable<GenericLambdaReturn<any>>

  {
    let params: any = {};
    console.log('Service Frequency: ', frequency)

    params.WorkType = work_type.toLowerCase();
    params.TimeToComplete = time_to_complete;
    params.RegionID = region_id;
    params.Description = work_description;
    params.PlantName = plant_name;
    params.Frequency = frequency;
    params.TeamID = team_id;
    params.VersionID = version_id;
    params.ServiceConfigID = service_config_id;


    console.log("Test: ", params);
    params.Variantid = variant_id;


    return this.post({
      ApiResource: "/work",
      data: {
        data: params
      }
    });
  }

  updateWorkBlock(plant_name:string, work_id: number, work_type: string, time_to_complete: number, region_id: number, work_description: string, frequency: number, variant_id: number, team_id: number, version_id: number, service_config_id: number):Observable<GenericLambdaReturn<any>>
  {
    let params: any = {};

    console.log(params);

    params.WorkID = work_id;
    params.WorkType = work_type.toLowerCase();
    params.TimeToComplete = time_to_complete;
    params.RegionID = region_id;
    params.Description = work_description;
    params.PlantName = plant_name;
    params.Frequency = frequency;
    params.Variantid = variant_id;
    params.TeamID = team_id;
    params.VersionID = version_id;
    params.ServiceConfigID = service_config_id;

    return this.post({
      ApiResource: "/work",
      data: {data: params},
      repeatCall: false
    })
  }

  deleteWorkBlock(work_id: number, pitch_config_id: number, team_id: number, version_id: number, type: string, description: string, plant_name):Observable<GenericLambdaReturn<any>>
  {
    let params: any = {};

    params.WorkID = work_id;
    params.PitchConfigID = pitch_config_id;
    params.TeamID = team_id;
    params.VersionID = version_id;
    params.type = type;
    params.description = description;
    params.PlantName = plant_name

    console.log(params)
    
    return this.delete({
      ApiResource: "/work",
      data: params,
      repeatCall: false
    })
  }


  saveTeamWork(plant_name: string, team_id: number, version_id: number, work_updates: WorkUpdatesType[]):Observable<GenericLambdaReturn<any>>
  {
    let params: any = {};

    params.PlantName = plant_name;
    params.TeamID = team_id;
    params.VersionID = version_id;

    params.WorkUpdates = work_updates;

    

    return this.post({
      ApiResource: "/worklocation",
      data: {data: params},
      repeatCall: false
    });
  }

  createPitchWorkConfig(pitch_config_id: number, variant_id: number, work_id: number, sort_order: number, pitch_status: string, plant_name: string){
    let params: any = {};

    params.PlantName = plant_name;
    params.PitchConfigID = pitch_config_id;
    params.VariantID = variant_id;
    params.WorkID = work_id;
    params.SortOrder = sort_order;
    params.PitchStatus = pitch_status;

    return this.post({
      ApiResource: "/pitchwork",
      data: {
        data: params
      }
    });
  }

  getTeamLog(team_id: number, version_id: number, records:number=100, log_type?:string) {
    let params: any = {};

    params.TeamID = team_id;
    params.VersionID = version_id;
    params.records = records;

    if(log_type){
      params.log_type = log_type;
    }

    return this.get({
      ApiResource: "/team/log",
      data: params,
      repeatCall: false
    }); 
  }

  getWorkFormatted(team_id: number, version_id: number): Observable<GenericLambdaReturn<TeamWorkFormatted>>{
    let params: any = {};

    params.TeamID = team_id;
    params.VersionID = version_id;

    return this.get({
      ApiResource: "/work/formatted",
      data: params,
      repeatCall: false
    });
  }

  getPDF(team_list: TeamVersion[], printSingleSided: boolean, skipEmptyPitches: boolean, printErgoScore: boolean, printSubassemblies:string, printServicePitches: string):Observable<Blob> {
    let params: any = {};    
    params.OverrideTwoSided = printSingleSided;
    params.SkipEmpty = skipEmptyPitches;
    params.PrintErgo = printErgoScore;
    params.TeamList = JSON.stringify(team_list);
    if(printSubassemblies){
      params.PrintSubassemblies = printSubassemblies
    }

    if(printServicePitches){
      params.PrintServicePitches = printServicePitches
    }
	
    return this.getBinary({
      ApiResource: "/team/pdf",
      data: params
    });
  }

  saveErgoScores(ErgoScores:any[], team_name: string, version_name: string, team_id: number, version_id: number, log_type: string):Observable<GenericLambdaReturn<any>>{
    let params: any = {};

    params.ErgoScore = ErgoScores;
    params.team_name = team_name;
    params.version_name = version_name;
    params.team_id = team_id;
    params.version_id = version_id;
    params.log_type = log_type;

    return this.post({
      ApiResource: "/ergo",
      data: params,
      repeatCall: false
    });
  }

}